import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { translate } from "../../translations/index.js";
import { ChangeEvent, useState } from "react";
import { USER_ROLES } from "../../utils/index.js";

import { useNavigate, Link } from "react-router";
import APIclient from "../../api-client/index.js";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const login = async () => {
    setError(false);
    try {
      const { role, jwtToken } = await APIclient.auth.sessions.create(
        email,
        password,
      );
      localStorage.setItem("jwt-token", jwtToken);
      localStorage.setItem("role", role);

      if (role === USER_ROLES.TEACHER) {
        navigate("/teacher");
      }
      if (role === USER_ROLES.ADMIN || role === USER_ROLES.SUPER_ADMIN) {
        navigate("/admin/users");
      }
    } catch {
      setError(true);
    }
  };

  return (
    <div className="container container--max-xs">
      <h1>{translate("auth.signin.title")}</h1>
      <ValidatorForm onSubmit={() => login()} className="login-container">
        <TextValidator
          name="email"
          className="normal-input"
          fullWidth
          required
          label={translate("auth.signin.email")}
          value={email}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setEmail(e.target.value)
          }
          validators={["required"]}
          errorMessages={["this field is required"]}
        />
        <TextValidator
          name="password"
          className="normal-input"
          fullWidth
          required
          type="password"
          label={translate("auth.signin.password")}
          value={password}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setPassword(e.target.value)
          }
          validators={["required"]}
          errorMessages={["this field is required"]}
        />
        <button className="button" type="submit">
          {translate("auth.signin.submit")}
        </button>
      </ValidatorForm>
      {error && (
        <p className="login-error-message">
          {translate("auth.signin.errorMessage")}
        </p>
      )}

      <div className="forgot-password-container">
        <Link to="/register" className="create-account-label">
          {translate("auth.signin.createAccount")}
        </Link>
        <Link to="/reset-password/init" className="forgot-password">
          {translate("auth.signin.forgotPassword")}
        </Link>
      </div>
    </div>
  );
}
